import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMapPin, FiBook, FiUser, FiChevronRight } = FiIcons;

const ExpertList = ({ experts, onExpertSelect }) => {
  const approvedExperts = experts.filter(expert => expert.status === 'approved');

  if (approvedExperts.length === 0) {
    return (
      <div className="expert-card h-[500px] flex items-center justify-center">
        <div className="text-center text-gray-500">
          <SafeIcon icon={FiUser} className="text-4xl mb-3 mx-auto" />
          <p>No experts found matching your criteria</p>
        </div>
      </div>
    );
  }

  return (
    <div className="expert-card h-[500px] overflow-hidden flex flex-col">
      <h3 className="text-xl font-bold text-gray-800 mb-4">
        Available Experts ({approvedExperts.length})
      </h3>
      
      <div className="flex-1 overflow-y-auto space-y-3 pr-2">
        {approvedExperts.map((expert, index) => (
          <motion.div
            key={expert.id}
            initial={{ x: 20, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: index * 0.1 }}
            className="bg-white border border-gray-200 rounded-lg p-4 hover:border-green-300 hover:shadow-md transition-all duration-200 cursor-pointer group"
            onClick={() => onExpertSelect(expert)}
          >
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <h4 className="font-semibold text-gray-800 group-hover:text-green-600 transition-colors">
                  {expert.full_name}
                </h4>
                
                <div className="flex items-center space-x-2 mt-1 text-sm text-gray-600">
                  <SafeIcon icon={FiMapPin} className="text-green-500" />
                  <span>{expert.city}, {expert.governorate}</span>
                </div>
                
                {expert.support_topics && expert.support_topics.length > 0 && (
                  <div className="mt-2 flex flex-wrap gap-1">
                    {expert.support_topics.slice(0, 2).map((topic, topicIndex) => (
                      <span
                        key={topicIndex}
                        className="px-2 py-1 bg-blue-100 text-blue-700 rounded-full text-xs"
                      >
                        {topic}
                      </span>
                    ))}
                    {expert.support_topics.length > 2 && (
                      <span className="text-xs text-gray-500 px-2 py-1">
                        +{expert.support_topics.length - 2}
                      </span>
                    )}
                  </div>
                )}
              </div>
              
              <SafeIcon
                icon={FiChevronRight}
                className="text-gray-400 group-hover:text-green-500 transition-colors"
              />
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ExpertList;